"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteStreamEvmOperation = void 0;
var dataTypes_1 = require("../../dataTypes");
exports.deleteStreamEvmOperation = {
    method: 'DELETE',
    name: 'deleteStreamEvm',
    id: 'DeleteStream',
    groupName: 'evmStreams',
    urlPathParamNames: ['id'],
    urlPathPattern: "/streams/evm/{id}",
    bodyParamNames: [],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        id: request.id,
    };
}
function getRequestBody() {
    return {};
}
function deserializeResponse(jsonResponse, request, core) {
    return dataTypes_1.EvmStream.create(jsonResponse, core);
}
function serializeRequest(request) {
    return {
        id: request.id,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        id: jsonRequest.id,
    };
}
//# sourceMappingURL=deleteStreamEvmOperation.js.map